import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const TabsWrapper = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 32px;
  justify-content: center;
  position: relative;
  width: 100%;
  border-bottom: 1px solid #cccccc;

  ${theme.breakpoints.down('md')} {
    margin-left: -16px;
    margin-right: -16px;
    width: calc(100% + 32px);
  }
`

export const Tab = styled.button`
  flex: 1;
  padding: 16px 0;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: ${({ active }) => (active ? '500' : '400')};
  color: ${({ active }) => (active ? '#0273FF' : '#262626')};
  cursor: pointer;
  transition: all 0.2s;
  background: none;
  border: none;
  border-bottom: 2px solid ${({ active }) => (active ? '#0273FF' : 'transparent')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -1px;

  &:hover {
    color: #0273ff;
  }

  ${theme.breakpoints.down('md')} {
    padding: 8px 16px;
    font-size: 16px;
    line-height: 24px;
    font-weight: ${({ active }) => (active ? '500' : '400')};
  }
`
